export const ALL = 'a78870ed5e8f48fe8458b283d7bf775b'
export const FISHING_GROUND = '8dc032409e1c4e83a8a118f62069f055'
export const HAVEN = '4e2e5464c7884db1be1384263ea2761d'
export const AIRPORT = 'fc9e932c3dca42e391510001622e99a6'
export const FACTORY = '5d9660f9c25249a78fb0b37fa618f967'
export const CUSTOMER = '324dc66b038849c09898bfca3bf538c0'
export const WHOLESALE_MARKET = 'fc1f00fd5f244d779c507808baac2959'



// WEBPACK FOOTER //
// ./src/static/shipping-point-type.js